import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaExternalLinkAlt, FaPlus} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useParams, useSearchParams} from "react-router";
import {useQuery} from "@tanstack/react-query";
import vehicleService from "../../../../services/web/vehicle-service.js";
import optionsUtils from "../../../../utils/options-utils.js";
import {getBrandModels} from "../../association-network/form/components/utils.js";
import {getCities} from "../../../../utils/location-utils.js";
import {MaskDefault} from "../../../../utils/mask.js";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import TableComponent from "./components/table-component.jsx";
import bosService from "../../../../services/web/bos-service.js";
import useHasPermission from "../../../../hooks/use-has-permission.js";
import {PermissionEnum} from "../../../../utils/enums/permission-enum.js";
import platePatternUtils from "../../../../utils/plate-pattern-utils.js";
import InputSwitch from "../../../../components/input/input-switch.jsx";
const API_URL = import.meta.env.VITE_API_URL;
const BASENAME = import.meta.env.BASE_URL;

const initialState = {
    id: "",
    plate: "",
    brandModel: "",
    type: "",
    numPorts: "",
    color: "",
    fabricationYear: "",
    modelYear: "",
    renavam: "",
    chassis: "",
    engineNumber: "",
    city: "",
    armoredVehicle: "",
    nameOwner: "",
    cpfCnpjOwner: "",
    ownerPhone: "",
    possessor: "",
    cpfCnpjPossessor: "",
    possessorPhone: "",
}

const portsOpt = [
    {value: "0", label: "0"},
    {value: "1", label: "1"},
    {value: "2", label: "2"},
    {value: "3", label: "3"},
    {value: "4", label: "4"},
    {value: "5", label: "5"},
]
const ReferenceVehicleForm = () => {
    const navigate = navigateHook();
    const hasPermission = useHasPermission();

    const occurrencePermission = hasPermission(PermissionEnum.OCCURRENCE)
    const encounterPermission = hasPermission(PermissionEnum.ENCOUNTER)
    const notesPermission = hasPermission(PermissionEnum.REFERENCE_VEHICLES_NOTES)
    const boPermission = hasPermission(PermissionEnum.BOGCM_WEB && PermissionEnum.BOGCM_VIEW_ALL)
    const boSubordinatePermission = hasPermission(PermissionEnum.BOGCM_WEB && PermissionEnum.BOGCM_VIEW_SUBORDINATES)
    const occurrenceIntelligencePermission = hasPermission(PermissionEnum.OCCURRENCE_INTELLIGENCE)
    const associabilityAnalysisPermission = hasPermission(PermissionEnum.ANALYSIS_NETWORK)
    const {id: idParam} = useParams()
    const [state, setState] = useState(initialState)
    const [detranType, setDetranType] = useState([])
    const [vehicleColor, setVehicleColor] = useState([])
    const [occurrences, setOccurrences] = useState([])
    const [bos, setBos] = useState([])
    const [note, setNote] = useState([])
    const [encounters, setEncounters] = useState([])
    const [boName, setBoName] = useState("")
    const [cortex, setCortex] = useState(false)
    const [cortexPlate, setCortexPlate] = useState("")
    const [searchParams] = useSearchParams();
    const [hasCortex, setHasCortex] = useState(false)
    const theme = useMemo(() => aggridUtils.generalTheme(), []);

    useEffect(() => {
        const plate = searchParams.get("plate");

        setState(prev => ({...prev, plate: platePatternUtils.formatPlate(plate)}))
    }, []);
    const onChange = ({target: {value, id}}) => {
        if (id === "plate") {
            value = platePatternUtils.formatPlate(value);
        }

        setState(prev => ({...prev, [id]: value}))
    }

    const handleInputs = (id, value) => setState(prev => ({...prev, [id]: value}));

    const handleFilters = (element) => {
        let {id, value, checked, type} = element.target;

        if (type === "checkbox") value = checked;
        setState(prev => ({...prev, [id]: value}));
    }

    const { refetch: refetch, isLoading} = useQuery({
        queryFn: () =>  vehicleService.get(idParam).then((data) => {
            if (data.redirect){
                navigateToCreate(data.plate)

                return data
            }
            let vehicle = data.vehicle
            let vehicleState = JSON.parse(vehicle.data)
            vehicleState.id = platePatternUtils.cleanRawPlate(vehicleState.plate)
            vehicleState.plate = platePatternUtils.formatPlate(vehicleState.plate)

            setState(vehicleState)
            setOccurrences(vehicle.occurrences ?? [])
            setBos(vehicle.bos ?? [])
            setNote(vehicle.notes ?? [])
            setEncounters(vehicle.encounters ?? [])
            setHasCortex(data.hasCortex)
            return data
        }),
        queryKey: ['vehicle', idParam],
        enabled: !!idParam,
    });

    const searchCortex = () => {
        if (hasCortex){
            if (!state.plate) {
                projectUtils.swalErrorMessage('', "Informe uma placa para realizar a pesquisa", 'Ok');
                return;
            }

            setCortexPlate(platePatternUtils.formatPlate(state.plate))
            setCortex(true)
        }
    }

    useQuery({
        queryFn: () =>  vehicleService.cortexRenavam({field: "placa", value: cortexPlate}).then(({data}) => {

            setState(prev => ({
                ...prev,
                brandModel: data.marcaModelo,
                city: data.municipioPlaca + " - " + data.ufEmplacamento,
                type: data.tipoVeiculo,
                color: data.cor,
                fabricationYear: data.anoFabricacao,
                modelYear: data.anoModelo,
                renavam: data.renavam,
                chassis: data.chassi,
                engineNumber: data.numeroMotor,
                nameOwner: data.proprietario.nomeProprietario,
                cpfCnpjOwner: data.proprietario.numeroDocumentoProprietario,
                possessor: data.possuidor.nomePossuidor,
                cpfCnpjPossessor: data.possuidor.numeroDocumentoPossuidor,
            }))
            setCortex(false)

            return data
        }).catch(error => {
            console.error(error);
            let message = 'Ocorreu um erro na requisição de dados do veículo.';
            if (error.response.status !== 500) {
                message = translateServerErrorMessage(error.response.data.message);
            }

            projectUtils.swalErrorMessage('', message, 'Ok');
        }),
        queryKey: ['cortexRenavam'],
        enabled: !!cortex
    });

    const translateServerErrorMessage = (message) => {
        let translateMessage;

        switch (message) {
            case 'cortex.vehiclesearch.filter.invalid': translateMessage = 'O campo "Placa" é obrigatório.'; break
            case 'cortex.token.invalid': translateMessage = 'Usuário sem permissão.'; break
            case 'cortex.token.expired': translateMessage = 'Permissão do usuário expirada.'; break
            case 'cortex.no.result': translateMessage = 'Nenhum resultado encontrado.'; break
            case 'cortex.responseerror':
            case 'cortex.ioerror':
            case 'cortex.error':
            default: translateMessage = 'Ocorreu um erro na requisição de dados do veículo.';
        }

        return translateMessage
    }

    useQuery({
        queryFn: () =>  vehicleService.getVehicleType().then(({data}) => {
            const newData = data.map(item => ({
                value: item.id,
                label: item.text,
            }));
            setDetranType(newData)
            return data
        }),
        queryKey: ['detranType'],

    });

    useQuery({
        queryFn: () =>  vehicleService.getVehicleColor().then(({data}) => {
            const newData = data.map(item => ({
                value: item.id,
                label: item.text,
            }));
            setVehicleColor(newData)
            return data
        }),
        queryKey: ['vehicleColor'],
    });

    useQuery({
        queryFn: () =>  bosService.getBoName().then((data) => {
            setBoName(data)
            return []
        }),
        queryKey: ['boName']
    });

    const save = () => {
        const formData = new FormData();

        Object.keys(state)
            .filter(key => !["city"].includes(key))
            .forEach(key => {
                let data = state[key];
                if (typeof data === 'object') data = data?.value ?? "";
                if (key === "plate") data = platePatternUtils.cleanRawPlate(data);

                if (key === "city") data = data === undefined ? "" : data
                formData.append(key, data);
            });

        if (state.id) formData.append('_method', 'PUT');

        formData.append("city-state", state.city)

        const response = state.id ? vehicleService.edit(state.id, formData) : vehicleService.create(formData);
        response
            .then(({data}) => {
                projectUtils.success(!idParam);

                if (idParam) {
                    refetch()
                    return;
                }

                navigateToEdit(data)
            })
            .catch((error) => {
                console.error(error);
                let message = 'Não foi possível salvar.';
                if (error.response.status !== 500) {
                    message = error.response.data.message;
                }

                projectUtils.swalErrorMessage("", message, "Ok");
            })

    }

    const destroy = () => {
        Swal.fire({
            title: "Excluir",
            text: `Excluir o veículo "${state.plate}"?`,
            icon: "warning",
            confirmButtonText: "Sim",
            confirmButtonColor: "#063A6C",
            cancelButtonText: "Não",
            cancelButtonColor: "#b91c1c",
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            reverseButtons: true
        }).then(({isConfirmed}) => {
            if (isConfirmed) {
                vehicleService.destroy(idParam).then(() => {
                    navigateToList()
                    projectUtils.success(true, "Excluído com sucesso");
                })
            }
        });
    }

    const navigateToList = () => {
        let isBlank = false;
        let urlDev = `/vehicle`;
        navigate(urlDev, isBlank);
    }

    const newVehicle = () => {
        setState(initialState);
        setOccurrences([]);
        setBos([]);
        setNote([]);
        setEncounters([]);
        setHasCortex(false);
        setCortex(false);
        setCortexPlate("");

        navigate("/vehicle/form", false);
    }

    const navigateToEdit = (data, verified = false) => {
        let isBlank = false;
        const plate = verified ? data : data.plate;
        let urlDev = `/vehicle/form/${platePatternUtils.cleanRawPlate(plate)}`;
        navigate(urlDev, isBlank);
    }

    const navigateToCreate = (data) => {
        let isBlank = false;
        let urlDev = `/vehicle/form?plate=${platePatternUtils.cleanRawPlate(data)}`;
        navigate(urlDev, isBlank);
    }

    const verifyPlate = (val) => {
        let plate = val;
        plate = platePatternUtils.cleanRawPlate(plate);

        if (platePatternUtils.existsByPlate(plate)) {
            vehicleService.get(plate).then((data) => {
                if (data.redirect) return

                let vehicle = data.vehicle
                let vehicleState = JSON.parse(vehicle.data)
                vehicleState.id = platePatternUtils.cleanRawPlate(vehicleState.plate)
                vehicleState.plate = platePatternUtils.formatPlate(vehicleState.plate)

                setState(vehicleState)
                setOccurrences(vehicle.occurrences ?? [])
                setBos(vehicle.bos ?? [])
                setNote(vehicle.notes ?? [])
                setEncounters(vehicle.encounters ?? [])
                setHasCortex(data.hasCortex)
                return data
            })
        }
    }

    const formatFullYear = (val) => {
        if (!val || typeof val !== 'string') return val;
        const regex = /^(\d{2})\/(\d{2})\/(\d{2})\s+(\d{2}:\d{2})$/;
        const match = val.match(regex);

        if (match) {
            return `${match[1]}/${match[2]}/20${match[3]} ${match[4]}`;
        }
        return val;
    };

    const extractDateForComparator = (val) => {
        if (!val || typeof val !== 'string') return val;

        const parts = val.trim().split(" ");

        const hasValidTime = parts.length > 1 && /^([01]?\d|2[0-3]):[0-5]\d/.test(parts[1]);

        if (!hasValidTime) {
            return parts[0];
        }

        return val;
    };

    //tables
    //occurrence
    const occurrenceRef = useRef(null);

    const occurrenceColumn = [
        { headerName: "Classificação", field: "classification", flex: 1, comparator: aggridUtils.nullLastComparator },
        { headerName: "Naturezas", field: "reason", flex: 1, comparator: aggridUtils.nullLastComparator },
        { headerName: "D/H inicial do fato", field: "dtIni", flex: 1, valueFormatter: (params) => formatFullYear(params.value),
            comparator: (a, b, nodeA, nodeB, isDescending) => {
                const formatedA = formatFullYear(a);
                const formatedB = formatFullYear(b);

                return aggridUtils.agGridCompareDateTime(formatedA, formatedB, nodeA, nodeB, isDescending);
            }},
        { headerName: "D/H final do fato", field: "dtEnd", flex: 1, valueFormatter: (params) => formatFullYear(params.value),
            comparator: (a, b, nodeA, nodeB, isDescending) => {
                const formatedA = formatFullYear(a);
                const formatedB = formatFullYear(b);

                return aggridUtils.agGridCompareDateTime(formatedA, formatedB, nodeA, nodeB, isDescending);
            }}
    ];

    const openOccurrences = ({data}) => {
        vehicleService.openAssociated(data.id)
            .then(() => {
                toast.success("A ocorrência associada será aberta no SentryView")
            })
            .catch(error => {
                console.error(error);
                toast.error('Ocorreu um erro ao abrir a ocorrência no SentryView.');
            });
    }

    //bos
    const bosRef = useRef(null);

    const bosColumn = [
        { headerName: "Número", field: "id", flex: 1, comparator: aggridUtils.nullLastComparator },
        { headerName: "Status", field: "status", flex: 1, comparator: aggridUtils.nullLastComparator },
        { headerName: "Natureza(s)", field: "reason", flex: 1, comparator: aggridUtils.nullLastComparator },
        { headerName: "D/H do fato", field: "dtfact", flex: 1,
            comparator: (a, b, nodeA, nodeB, isDescending) => {
                const formatedA = extractDateForComparator(a);
                const formatedB = extractDateForComparator(b);

                return aggridUtils.agGridCompareDateTime(formatedA, formatedB, nodeA, nodeB, isDescending);
            }, sort: "desc" }
    ];

    const onClickBo = ({data}) => {
        window.open(`${BASENAME}bo/${data.id.replace("/", "-") }`)
    }

    //notes
    const notesRef = useRef(null);

    const notesColumn = [
        { headerName: "Observação", field: "note", flex: 1, comparator: aggridUtils.nullLastComparator },
        { headerName: "D/H criação", field: "createdatetime", flex: 1, comparator: aggridUtils.agGridCompareDateTime },
        { headerName: "D/H atualização", field: "updatedatetime", flex: 1, comparator: aggridUtils.agGridCompareDateTime },
    ];

    const onClickNote = ({data}) => {
        window.open(`${BASENAME}vehicle-notes/form/${data.id}`)
    }

    //encounters
    const encountersRef = useRef(null);

    const encountersColumn = [
        { headerName: "Abordado por", field: "userNameWar", flex: 1, comparator: aggridUtils.nullLastComparator },
        { headerName: "D/H inicial", field: "dtStart", flex: 1, comparator: aggridUtils.agGridCompareDateTime },
        { headerName: "Observação", field: "observation", flex: 1, comparator: aggridUtils.nullLastComparator },
    ];

    const onClickEncounters = ({data}) => {
        window.open(`${BASENAME}encounter/form/${data.id}`)
    }

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title browserTitle={`${state?.plate ? state?.plate : 'Informações do veículo'}`}>
                    Informações do veículo
                </Template.Title>
                {
                    state.id &&
                    <>
                        <div className={"flex gap-4"}>
                            {
                                associabilityAnalysisPermission &&
                                    <Button target={"primary-outline"} onClick={() => window.open(`${BASENAME}association-network/form?plate=${platePatternUtils.cleanRawPlate(state.plate)}`)}>
                                        <FaExternalLinkAlt/><span className="font-bold">Rede de associação</span>
                                    </Button>
                            }

                            <Button target={"primary-outline"} onClick={() => newVehicle()}>
                                <FaPlus/>
                                Adicionar veículo
                            </Button>
                        </div>
                    </>
                }
            </Template.Header>

            <Template.Body>
                <Card>
                    <Card.Header>
                        <Card.Title>Dados do veículo</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <div className="col-span-10 relative">
                            <div className="grid grid-cols-12 gap-4 mb-3">
                                <div className="flex col-span-4 gap-2">
                                    <InputForm classNameWrapper={"w-full"} id="plate" value={state.plate} onChange={onChange}
                                               label="Placa *" onBlur={() => verifyPlate(state.plate)}/>
                                    <Button target={"primary-outline"} onClick={searchCortex}>
                                        <img className={"w-5 h-5"}
                                            src={`${API_URL}/public/assets/img/${hasCortex ? "cortex-enabled" : "cortex-disabled"}.svg`}
                                             alt={"cortex"}
                                        ></img>
                                    </Button>
                                </div>
                                <div className="col-span-5">
                                    <SelectComponent
                                        loadOptions={getBrandModels}
                                        value={optionsUtils.getValue(state?.brandModel)}
                                        isAsync={true}
                                        label={"Marca/Modelo"}
                                        onChange={(selected) => handleInputs("brandModel", selected?.value)}
                                        cacheOptions
                                        defaultOptions={[]}
                                    />
                                </div>
                                <div className="col-span-3 gap-4 flex">
                                    <SelectComponent
                                        name="type"
                                        value={detranType.find(t => t.value === state?.type)}
                                        options={detranType}
                                        label={"Tipo (Detran)"}
                                        onChange={(selected) => handleInputs("type", selected?.value)}
                                        classNameWrapper={"w-full"}
                                    />

                                    <InputSwitch
                                        id="armoredVehicle"
                                        label="Blindado"
                                        checked={state.armoredVehicle}
                                        onChange={handleFilters}
                                    />
                                </div>

                                <div className="col-span-2">
                                    <SelectComponent
                                        name="numPorts"
                                        value={portsOpt.find(t => t.value === state?.numPorts)}
                                        options={portsOpt}
                                        label={"Portas"}
                                        onChange={(selected) => handleInputs("numPorts", selected?.value)}
                                    />
                                </div>
                                <div className="col-span-4">
                                    <SelectComponent
                                        name="color"
                                        value={vehicleColor.find(t => t.value === state?.color)}
                                        options={vehicleColor}
                                        label={"Cor"}
                                        onChange={(selected) => handleInputs("color", selected?.value)}
                                    />
                                </div>
                                <div className="col-span-3">
                                    <InputForm id="fabricationYear" value={state.fabricationYear} onChange={onChange}
                                               label="Ano de fabricação"/>
                                </div>
                                <div className="col-span-3">
                                    <InputForm id="modelYear" value={state.modelYear} onChange={onChange}
                                               label="Ano do modelo"/>
                                </div>

                                <div className="col-span-3">
                                    <InputForm id="renavam" value={state.renavam} onChange={onChange} mask={MaskDefault.renavam}
                                               label="RENAVAM"/>
                                </div>
                                <div className="col-span-3">
                                    <InputForm id="chassis" value={state.chassis} onChange={onChange}
                                               label="Chassi"/>
                                </div>
                                <div className="col-span-3">
                                    <InputForm id="engineNumber" value={state.engineNumber} onChange={onChange}
                                               label="Motor"/>
                                </div>
                                <div className="col-span-3">
                                    <SelectComponent
                                        loadOptions={getCities}
                                        value={optionsUtils.getValue(state?.city)}
                                        isAsync={true}
                                        label="Município da placa"
                                        onChange={(selected) => handleInputs("city", selected?.value)}
                                        cacheOptions
                                        defaultOptions={[]}
                                    />
                                </div>

                                <div className="col-span-6">
                                    <InputForm id="nameOwner" value={state.nameOwner} onChange={onChange}
                                               label="Nome do proprietário"/>
                                </div>
                                <div className="col-span-3">
                                    <InputForm id="cpfCnpjOwner" value={state.cpfCnpjOwner} onChange={onChange} mask={MaskDefault.cpfAndCnpj}
                                               label="CPF/CNPJ do proprietário"/>
                                </div>
                                <div className="col-span-3">
                                    <InputForm id="ownerPhone" value={state.ownerPhone} onChange={onChange} mask={MaskDefault.phone}
                                               label="Telefone do proprietário"/>
                                </div>

                                <div className="col-span-6">
                                    <InputForm id="possessor" value={state.possessor} onChange={onChange}
                                               label="Nome do possuidor"/>
                                </div>
                                <div className="col-span-3">
                                    <InputForm id="cpfCnpjPossessor" value={state.cpfCnpjPossessor} onChange={onChange} mask={MaskDefault.cpfAndCnpj}
                                               label="CPF/CNPJ do possuidor"/>
                                </div>
                                <div className="col-span-3">
                                    <InputForm id="possessorPhone" value={state.possessorPhone} onChange={onChange} mask={MaskDefault.phone}
                                               label="Telefone do possuidor"/>
                                </div>

                            </div>
                        </div>
                    </Card.Body>
                </Card>

                {
                    state.id &&
                    <>

                        <TableComponent
                            permission={occurrencePermission}
                            theme={theme}
                            data={occurrences}
                            title={<>
                                <div>Sentry View - Ocorrências associadas</div>
                                <div>{`${occurrences.length > 0 ? ` Total: ${occurrences.length}` : ""}`}</div>
                                </>
                            }
                            notInvolved={`Nenhum registro encontrado.`}
                            ref={occurrenceRef}
                            column={occurrenceColumn}
                            onCellClicked={openOccurrences}
                        />

                        <TableComponent
                            permission={boPermission || boSubordinatePermission}
                            theme={theme}
                            data={bos}
                            title={<>
                                <div>{`Despacho - ${boName} associados`}</div>
                                <div>{`${bos.length > 0 ? ` Total: ${bos.length}` : ""}`}</div>
                            </>
                            }
                            notInvolved={`Nenhum registro encontrado`}
                            ref={bosRef}
                            column={bosColumn}
                            onCellClicked={onClickBo}
                        />

                        <TableComponent
                            permission={notesPermission}
                            theme={theme}
                            data={note}
                            title={<>
                                <div>Anotações associadas</div>
                                <div>{`${note.length > 0 ? ` Total: ${note.length}` : ""}`}</div>
                            </>
                            }
                            notInvolved={`Nenhum registro encontrado.`}
                            ref={notesRef}
                            column={notesColumn}
                            onCellClicked={onClickNote}
                        />

                        <TableComponent
                            permission={encounterPermission}
                            theme={theme}
                            data={encounters}
                            title={<>
                                <div>Abordagens associadas</div>
                                <div>{`${encounters.length > 0 ? ` Total: ${encounters.length}` : ""}`}</div>
                            </>
                            }
                            notInvolved={`Nenhum registro encontrado.`}
                            ref={encountersRef}
                            column={encountersColumn}
                            onCellClicked={onClickEncounters}
                        />

                    </>
                }

                <Card className={"mt-2"}>
                    <Card.Body>
                        <div className="w-full flex justify-end">
                            <div className="flex gap-2">
                                {
                                    state.id &&
                                    <>
                                        <Button target="danger" onClick={destroy} actionFeedbackType='delete'>

                                            Excluir
                                        </Button>
                                    </>
                                }

                                <Button onClick={save} actionFeedbackType='save'>

                                    Salvar
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default ReferenceVehicleForm;